<script lang="ts">
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import type { SbMuxVideo, SbOverlay } from '../types';
	import HeroBase from '../components/hero/heroBase.svelte';

	interface Props {
		content: ISbStoryData<{
			headline: ISbRichtext;
			headline_style: 'bold' | 'regular';
			subheadline: ISbRichtext;
			buttons: ISbStoryData[];
			background_asset_mobile: ISbStoryData[];
			background_asset_desktop: ISbStoryData[];
			overlay_desktop: SbOverlay;
			overlay_mobile: SbOverlay;
			video_teaser_mobile: ISbStoryData<SbMuxVideo>[];
			video_teaser_desktop: ISbStoryData<SbMuxVideo>[];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<HeroBase
	content={{
		...content,
		text_alignment_desktop: 'left-bottom',
		text_alignment_mobile: 'left-bottom'
	}}
/>
